import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { patientAction } from '../../actions/constant';
import patientService from 'src/services/apiServices/patientServices';

const {
  GET_RECENT_UPLOADED_HISTORY_FAILURE,
  GET_RECENT_UPLOADED_HISTORY_REQUEST,
  GET_RECENT_UPLOADED_HISTORY_SUCCESS,
  GET_RECENT_UPLOADED_HISTORY_LOADING,
} = patientAction;

function* getRecentUploadedHistory(): SagaReturnType<any> {
  try {
    yield put({ type: GET_RECENT_UPLOADED_HISTORY_LOADING });
    const response = yield call(patientService.getPatientHistory);
    if (response?.status === 200) {
      yield put({ type: GET_RECENT_UPLOADED_HISTORY_SUCCESS, payload: response });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_RECENT_UPLOADED_HISTORY_FAILURE, payload: error });
  }
}

function* getRecentUploadedHistorySaga() {
  yield takeEvery(GET_RECENT_UPLOADED_HISTORY_REQUEST, getRecentUploadedHistory);
}

export default getRecentUploadedHistorySaga;
